<template>
  <div>error 404???</div>
</template>

<script>
export default {
  name: "error_404"
}
</script>

<style scoped>

</style>
